// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_7l1Uj","empty":"empty_e0sN0"};